import { connect } from 'react-redux';
import layoutModule from 'app/store/layout';
import sessionsModule from 'app/store/sessions';
import StepTickets from './StepTickets.component';
import paymentModule from 'app/store/payment';
import giftcardsModule from 'app/store/giftcards';
import orderModule from 'app/store/order';
import concessions from 'app/store/concessions';
import sessionsTicketsModule from 'app/store/sessionsTickets';

const { wizardSet, wizardClear } = sessionsModule.actions;
const { createToast } = layoutModule.actions;
const { clearTicketSessionSend, clearPaymentStatus } = paymentModule.actions;
const { clearGiftcardSessionSend } = giftcardsModule.actions;
const { clearOrder } = orderModule.actions;
const { setConcessionOnServer, setConcessionComboOnServer } = concessions.actions;

const { requestSesseionsBookingCount } = sessionsTicketsModule.actions;
const mapStateToProps = ({ sessions: { wizard, session }, user: { user } }) => {
  const { child, adult, reduced, isBonus, packageRegular, packageChild, packageReduced, packageClub } = wizard;
  const { maxTickets, maxReservedTickets, maxBonusCardTickets } = session.restrictions;
  const { hasChildTickets, hasReducedTickets, hasRegularTickets, hasPackageRegular, hasPackageReduced, hasPackageChild, hasPackageClub } = session;
  const bonusCardBalance = session?.userBalance?.cardBalance;

  return {
    child,
    adult,
    reduced,
    isBonus,
    packageRegular,
    packageChild,
    packageReduced,
    packageClub,
    hasChildTickets,
    hasReducedTickets,
    hasRegularTickets,
    hasPackageRegular,
    hasPackageReduced,
    hasPackageChild,
    hasPackageClub,
    maxTickets,
    maxReservedTickets,
    maxBonusCardTickets,
    bonusCardBalance,
    isLoggedIn: !!user,
    sessionData: session
  };
};

const mapDispatchToProps = {
  saveWizard: wizardSet,
  notify: createToast,
  clearTicketSession: clearTicketSessionSend,
  clearGiftcardSession: clearGiftcardSessionSend,
  clearMainSession: wizardClear,
  clearPaymentStatus,
  clearOrder,
  setConcessionOnServer,
  setConcessionComboOnServer,
  bookingCount: requestSesseionsBookingCount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepTickets);
